import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VExpansionPanel } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelContent } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanelHeader } from 'vuetify/lib/components/VExpansionPanel';
import { VExpansionPanels } from 'vuetify/lib/components/VExpansionPanel';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "min-w-0 w-full" },
    [
      _c("div", { staticClass: "display-1" }, [
        _vm._v(_vm._s(_vm.$t("performance_evaluation.evaluation"))),
      ]),
      _c(
        "actions-component",
        {
          staticClass: "mt-1",
          scopedSlots: _vm._u([
            {
              key: "description",
              fn: function () {
                return [
                  _c("span", [
                    _vm._v(
                      _vm._s(_vm.$t("performance_evaluation.des_evaluation"))
                    ),
                  ]),
                ]
              },
              proxy: true,
            },
          ]),
        },
        [
          _c(
            "template",
            { slot: "actions" },
            [
              _c(
                VBtn,
                {
                  staticClass: "ml-1 btn-inca-secondary",
                  attrs: { dense: "", outlined: "" },
                  on: { click: _vm.onReload },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("performance_evaluation.reload")) + " "
                  ),
                ]
              ),
            ],
            1
          ),
        ],
        2
      ),
      _c(
        VCard,
        { staticClass: "mt-1" },
        [
          _vm.loading
            ? _c(
                VContainer,
                { staticClass: "loading-frame", attrs: { "fill-height": "" } },
                [
                  _c(
                    VRow,
                    { attrs: { justify: "center", align: "center" } },
                    [
                      _c(VCol, { attrs: { cols: "12", sm: "4" } }, [
                        _c(
                          "div",
                          { staticClass: "text-center" },
                          [
                            _c(VProgressCircular, {
                              attrs: {
                                size: 50,
                                width: 5,
                                color: "primary",
                                indeterminate: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.canRenderFrame
            ? _c("iframe", {
                key: _vm.keyFrame,
                ref: "evaluationFrame",
                staticStyle: { border: "0", display: "block" },
                attrs: {
                  src: _vm.evaluationUrl,
                  frameborder: "0",
                  width: "100%",
                  height: _vm.frameHeight,
                  allowfullscreen: "",
                },
                on: { load: _vm.onFrameLoad },
              })
            : !_vm.loading
            ? _c("state-component", {
                attrs: {
                  state: "empty_state",
                  title: _vm.errorTitle,
                  subtitle: _vm.errorDetail,
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _vm.isLocalEnv
        ? _c(
            VExpansionPanels,
            { staticClass: "mt-2" },
            [
              _c(
                VExpansionPanel,
                [
                  _c(VExpansionPanelHeader, { staticClass: "caption" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.$t("performance_evaluation.debug_title")) +
                        " "
                    ),
                  ]),
                  _c(VExpansionPanelContent, [
                    _c("div", { staticClass: "caption text-break" }, [
                      _c("b", [_vm._v("src:")]),
                      _vm._v(" " + _vm._s(_vm.evaluationUrl)),
                    ]),
                    _c("div", { staticClass: "caption" }, [
                      _c("b", [_vm._v("nuestro origin:")]),
                      _vm._v(" " + _vm._s(_vm.ourOrigin)),
                    ]),
                    _c("div", { staticClass: "caption" }, [
                      _c("b", [_vm._v("origin destino:")]),
                      _vm._v(" " + _vm._s(_vm.targetOrigin)),
                    ]),
                    _c("div", { staticClass: "caption" }, [
                      _c("b", [_vm._v("audiencia:")]),
                      _vm._v(" " + _vm._s(_vm.audience)),
                    ]),
                    _c("div", { staticClass: "caption" }, [
                      _c("b", [_vm._v("postMessage type:")]),
                      _vm._v(
                        " " +
                          _vm._s(_vm.lastSentType || "—") +
                          " (" +
                          _vm._s(_vm.sendCount) +
                          " envios)"
                      ),
                    ]),
                    _c("div", { staticClass: "caption text-break" }, [
                      _c("b", [_vm._v("token:")]),
                      _vm._v(" " + _vm._s(_vm.resumenToken(_vm.token))),
                    ]),
                    _c("div", { staticClass: "caption" }, [
                      _c("b", [_vm._v("reenvios por expiracion:")]),
                      _vm._v(" " + _vm._s(_vm.refreshCount)),
                    ]),
                  ]),
                ],
                1
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }